import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthEffects } from './state/effects/auth.effects';
import { authFeatureKey, reducers as authReducers } from './state/reducers/index';
import { UserTenantEffects } from './state/effects/user-tenant.effects';
import { LogoutEffect } from './state/effects/logout.effect';
import { SigninComponent } from './components/signin/signin.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { PwdResetRequestComponent } from './components/pwd-reset-request/pwd-reset-request';
import { SignupComponent } from './components/singup/signup.component';
import { CheckYourEmailComponent } from './components/check-your-email/check-your-email.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ProfileUpdateEffects } from './state/effects/profile-update.effects';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ActivateAccountComponent } from './components/activate-account/activate-account.component';
import { ConnectComponent } from './components/connect/connect.component';

const materialModules = [
  MatButtonModule,
  MatFormFieldModule,
  MatInputModule,
  MatIconModule,
  MatDialogModule,
  MatSnackBarModule,
  MatCheckboxModule
];

@NgModule({
    imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        MatProgressSpinnerModule,
        RouterModule,
        StoreModule.forFeature(authFeatureKey, authReducers),
        TranslateModule,
        EffectsModule.forFeature([
            AuthEffects,
            UserTenantEffects,
            LogoutEffect,
            ProfileUpdateEffects,
        ]),
        ...materialModules, SigninComponent,
        ResetPasswordComponent,
        PwdResetRequestComponent,
        SignupComponent,
        ActivateAccountComponent,
        CheckYourEmailComponent,
        ConnectComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AuthModule {}
